export enum ImportFilesMode {
    Default = '',
    Replace = 'replace',
    SkipConflicts = 'skipConflicts',
}